import React from "react";
import { Container, Col, Button } from "reactstrap";
import ModalComponent from "~/components/ModalComponent";
import { mailTo, isDesktopApp } from "~/utils/misc";
import { canUseDOM } from "fbjs/lib/ExecutionEnvironment";

export default function helpModalElement() {
  return (
    <ModalComponent
      className="help_modal"
      onRef={ref => {
        this.helpModal = ref;
      }}
    >
      <Container>
        <Col className="display_container">
          <h4>Contact:</h4>
          <p className="intro">If you've found a bug or have any questions or feedback for this game, please don’t hesitate to write me at <a href="#" onClick={mailTo}>
            contact@online-jigsaw-puzzles.com
          </a>. I'm always happy to hear from you, so let me know if you have any ideas for improvements or suggestions for new features.</p>
          <h4>FAQ:</h4>
          <ul>
            <li><b>How do I rotate a piece?</b><br/>Simply right-click on the piece and it will turn.</li>
            <li><b>How do I move a piece?</b><br/>Click and drag a piece to move it.</li>
            <li><b>How do I know if two pieces belong together?</b><br/>If two pieces belong together and you put them together correctly, they will "click" together and make a little sound.</li>
            <li><b>Who do I write about a bug?</b><br/>Please write me at <a href="#" onClick={mailTo}>
              contact@online-jigsaw-puzzles.com
            </a>. If you've found a bug, then please describe it as clearly as possible.</li>
            <li><b>Who do I write about feedback and ideas for the game?</b><br/>Please write me at <a href="#" onClick={mailTo}>
              contact@online-jigsaw-puzzles.com
            </a>.</li>
            <li><b>How can I turn off the sound?</b><br/>You can turn the sound off and on under settings.</li>
            <If condition={is.truthy(canUseDOM) && isDesktopApp()}>
              <li><b>How can I restore the purchase?</b><br/>If you've bought the game before, then you can restore the purchase by clicking "Restore purchase" from the main menu or the purchase popup.</li>
            </If>
            <li><b>Do you have any other games you can recommend?</b><br/>I'm a big fan of domino games and recently I've been playing a lot of Mexican Train Dominoes. My favorite place to play is on: <a href="https://mexicantrain.online/">mexicantrain.online</a>.</li>
          </ul>
        </Col>
      </Container>
    </ModalComponent>
  );
}



// WEBPACK FOOTER //
// ./src/components/MenuComponent/helpers/helpModalElement.js